import { render, staticRenderFns } from "./IntersectionObservable.vue?vue&type=template&id=210f16b7"
import script from "./IntersectionObservable.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntersectionObservable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports